module.exports = __webpack_public_path__ + "img/verified.33323797.svg";